import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import GoogleCallback from "@/components/GoogleCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import ClientDashboard from "@/pages/ClientDashboard";
import UploadInvoice from "@/pages/UploadInvoice";
import InvoiceDetail from "@/pages/InvoiceDetail";
import AccountantDashboard from "@/pages/AccountantDashboard";
import AccountantSettings from "@/pages/AccountantSettings";
import MessagesPage from "@/pages/MessagesPage";
import TocOnlineHistory from "@/pages/TocOnlineHistory";
import FiscalCalendar from "@/pages/FiscalCalendar";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster richColors position="top-right" />
        </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  // Google OAuth return: session_id arrives in the URL fragment — process it before any routing.
  if (location.hash?.includes("session_id=")) return <GoogleCallback />;
  return (
    <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/recuperar/:token" element={<ResetPassword />} />
            <Route path="/convite/:token" element={<AcceptInvite />} />

            <Route path="/cliente" element={
              <ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>
            } />
            <Route path="/cliente/nova-fatura" element={
              <ProtectedRoute role="client"><UploadInvoice /></ProtectedRoute>
            } />
            <Route path="/cliente/fatura/:id" element={
              <ProtectedRoute role="client"><InvoiceDetail /></ProtectedRoute>
            } />
            <Route path="/cliente/mensagens" element={
              <ProtectedRoute role="client"><MessagesPage /></ProtectedRoute>
            } />

            <Route path="/contabilista" element={
              <ProtectedRoute role="accountant"><AccountantDashboard /></ProtectedRoute>
            } />
            <Route path="/contabilista/fatura/:id" element={
              <ProtectedRoute role="accountant"><InvoiceDetail /></ProtectedRoute>
            } />
            <Route path="/contabilista/empresas" element={<Navigate to="/contabilista/definicoes?tab=empresas" replace />} />
            <Route path="/contabilista/equipa" element={<Navigate to="/contabilista/definicoes?tab=equipa" replace />} />
            <Route path="/contabilista/definicoes" element={
              <ProtectedRoute role="accountant"><AccountantSettings /></ProtectedRoute>
            } />
            <Route path="/contabilista/mensagens/:companyId" element={
              <ProtectedRoute role="accountant"><MessagesPage /></ProtectedRoute>
            } />
            <Route path="/contabilista/historico" element={
              <ProtectedRoute role="accountant"><TocOnlineHistory /></ProtectedRoute>
            } />
            <Route path="/contabilista/calendario" element={
              <ProtectedRoute role="accountant"><FiscalCalendar /></ProtectedRoute>
            } />
          </Routes>
  );
}
